import { SvgIcon } from '@mui/material';
import React from 'react';

export default function LeftCurveIcon({ ...props }) {
  return (
    <SvgIcon
      fill="none"
      height="8"
      viewBox="0 0 28 8"
      width="28"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        clip-rule="evenodd"
        d="M0.421322 7.96559C0.587809 7.97783 0.755016 7.98914 0.922945 7.99951H0.427624L0.421322 7.96559ZM15.3724 7.99951C20.357 7.80331 23.4586 7.19463 25.3793 5.35384C26.561 4.22131 27.2958 2.62239 27.7471 0.366213V7.99951H15.3724Z"
        fill="black"
        fill-opacity="0.4"
        fill-rule="evenodd"
      />
    </SvgIcon>
  );
}
